<template>
  <BasicTemplate>
    <v-card>

      <v-card-title class="d-flex">
        <h3>Developers</h3>
        <v-btn class="ml-4" color="success" @click="$router.push('/developers/new')">Create</v-btn>
      </v-card-title>

      <v-card-text>
        <v-text-field label="Search" v-model="search" />
        <v-data-table :loading="items.length === 0" :headers="headers" :items="items" :search="search">
          <template v-slot:item.actions="{ item }">
            <v-icon
              class="mr-2"
              :data-testid="`developers-edit-${item.id}`"
              @click="editItem(item)"
              color="primary"
            >mdi-pencil</v-icon>
            <v-icon
              :data-testid="`developers-delete-${item.id}`"
              @click="deleteItem(item)"
              color="warning"
            >mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-card-text>

    </v-card>
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../templates/basic.vue';

export default {
  name: 'DevelopersList',
  components: { BasicTemplate },
  data() {
    return {
      search: '',
      items: [],
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Azure Ad Id (studio name)', value: 'azureAdId' },
        { text: 'Actions', value: 'actions', align: 'center' },
      ],
    };
  },
  async created() {
    this.items = await this.$gameApi.get('/users');
  },
  methods: {
    async editItem(item) {
      this.$router.push(`/developers/${item.id}`);
    },
    async deleteItem(item) {
      const { isConfirmed } = await this.$swal.fire({ icon: 'warning', title: 'This will delete all developer infromation including all games belonging to this developer. Are you sure to proceed?', showCancelButton: true });
      if (isConfirmed) {
        await this.$gameApi.delete(`/users/${item.id}`);
        this.items = await this.$gameApi.get('/users/');
      }
    },
  }
};
</script>

